"use strict";

var _classCallCheck = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var innedit_1 = require("@innedit/innedit");

var Evenement = /*#__PURE__*/function () {
  function Evenement() {
    _classCallCheck(this, Evenement);
  }

  _createClass(Evenement, null, [{
    key: "create",
    value: function create(data) {
      var eventModel = new innedit_1.EventData({
        espaceId: String(process.env.GATSBY_ID_BOUTIQUE)
      });
      return eventModel.create(data);
    }
  }]);

  return Evenement;
}();

exports.default = Evenement;